import React, { useState, useEffect, useRef, useCallback } from 'react';
import "@fortawesome/fontawesome-free/css/all.min.css";
import { db } from '../FirebaseComp/firebase';  
import { collection, addDoc } from "firebase/firestore";
import emailjs from 'emailjs-com';
import './booking.css'

function Booking() {
  const [step, setStep] = useState(1);
  const [pickup, setPickup] = useState('');
  const [dropoff, setDropoff] = useState('');
  const [childrenCount, setChildrenCount] = useState(0);
  const [adultsCount, setAdultsCount] = useState(1);
  const [vehicleType, setVehicleType] = useState('Suzuki Wagon R');
  const [transferType, setTransferType] = useState('one-way');
  const [pickupDate, setPickupDate] = useState('');
  const [pickupTime, setPickupTime] = useState('');
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [comment, setComment] = useState('');
  const [loading, setLoading] = useState(false);

  const handleDateChange = (e) => {
    const selectedDate = new Date(e.target.value);
    const today = new Date();
    today.setHours(0, 0, 0, 0);
  
    if (selectedDate >= today) {
      setPickupDate(e.target.value);
    } else {
      alert("Please select today or a future date.");
    }
  };

  const handleTimeChange = (e) => {
    setPickupTime(e.target.value);
  };

  const generateTimeOptions = () => {
    const timeOptions = [];
    for (let hour = 0; hour < 24; hour++) {
      for (let minute = 0; minute < 60; minute += 30) {
        const formattedHour = hour.toString().padStart(2, '0');
        const formattedMinute = minute.toString().padStart(2, '0');
        timeOptions.push(`${formattedHour}:${formattedMinute}`);
      }
    }
    return timeOptions;
  };

  const handleNextStep = () => {
    if (step === 1 && pickup && dropoff) {
      setStep(2);
    } else if (step === 2 && pickupDate && pickupTime) {
      setStep(3);
    } else if (step === 3 && firstName && lastName && (email || phone)) {
      setStep(4);
    }
  };

  const handlePreviousStep = () => {
    if (step > 1) {
      setStep(step - 1);
    }
  };

  const getStepClass = (currentStep) => {
    if (currentStep === step) {
      return 'active';
    } else if (currentStep < step) {
      return 'completed';
    }
    return 'inactive';
  };

  const handleBookingSubmit = async () => {
    if (!pickup || !dropoff || !vehicleType || !pickupDate || !pickupTime || !firstName || !lastName || (!email && !phone)) {
      alert("Please complete all required fields before booking. You must provide either an email address or a phone number.");
      return;
    }

    setLoading(true);
    try {
      // Add booking to Firestore
      await addDoc(collection(db, "bookings"), {
        pickup,
        dropoff,
        childrenCount,
        adultsCount,
        vehicleType,
        transferType,
        pickupDate,
        pickupTime,
        firstName,
        lastName,
        email,
        phone,
        comment,
      });

      // Send email
      const emailData = {
        pickup,
        dropoff,
        childrenCount,
        adultsCount,
        vehicleType,
        transferType,
        pickupDate,
        pickupTime,
        firstName,
        lastName,
        email,
        phone,
        comment,
      };

      await emailjs.send(
        'service_22or7mg',
        'template_z3z3yim',
        emailData,
        'pNle7yEw5kA2fLPDN'
      );

      alert("Booking has been successful!");
    } catch (error) {
      console.error("Error during booking: ", error);
      alert("There was an error processing your booking. Please try again.");
    } finally {
      setLoading(false);
    }
  };














// tour cost calculation states
  const [selectedVehicle, setSelectedVehicle] = useState(null);
  const [kilometers, setKilometers] = useState(100);
  const [cost, setCost] = useState(0);
  const [isDragging, setIsDragging] = useState(false);
  const sliderRef = useRef(null);

  const vehicles = [
    {
      id: 1,
      name: "Car (Sedan / Med)",
      models: "Toyota Prius, Toyota Axio, Toyota Corolla, Honda Grace, Suzuki Swift, Suzuki Swift Dzire, Nissan Sunny",
      capacity: "1-4 passengers, 2-3 medium bags",
      comfort: "A/C, good for city tours, airport transfers, and long-distance trips",
      pricePerKm: 130,
      usdPrice: 0.40
    },
    {
      id: 2,
      name: "Car (Small/Flex)",
      models: "Panda, Selaran, Toyota Vitz, Suzuki Alto/Wagon R, Toyota Aqua, Nissan March, Perodua Axia",
      capacity: "1-3 passengers, 1-2 medium bags",
      comfort: "Economical option for small groups",
      pricePerKm: 100,
      usdPrice: 0.33
    },
    {
      id: 3,
      name: "Van (Mini Van / Family Van)",
      models: "Toyota KDH (Hiace), Toyota Noah, Toyota Voxy, Nissan Serena, Toyota KDH 200/201, Nissan Caravan, KDH Flat Roof",
      capacity: "5-6 passengers",
      comfort: "Ideal for family trips",
      pricePerKm: 150,
      usdPrice: 0.50
    },
    {
      id: 4,
      name: "Large Van",
      models: "Toyota Coaster, Nissan Civilian, KDH High Roof, Dolfing",
      capacity: "8-9 passengers",
      comfort: "Great for larger groups",
      pricePerKm: 175,
      usdPrice: 0.58
    },
    {
      id: 5,
      name: "SUV",
      models: "Chevrolet Captiva, Hyundai Santa Fe, KIA Sorento, Nissan X-Trail, Hyundai Tucson, Honda CR-V, Honda Vezel",
      capacity: "5-7 passengers",
      comfort: "Comfortable for all terrains",
      pricePerKm: 190,
      usdPrice: 0.63
    },
    {
      id: 6,
      name: "Full-Size Bus",
      models: "Yutong, Mitsubishi Rosa (large size)",
      capacity: "25-40 passengers",
      comfort: "For large groups and tours",
      pricePerKm: 270,
      usdPrice: 0.90
    }
  ];

  useEffect(() => {
    if (selectedVehicle) {
      const calculatedCost = kilometers * selectedVehicle.pricePerKm;
      setCost(calculatedCost);
    }
  }, [selectedVehicle, kilometers]);

  const handleSliderInteraction = useCallback((clientX) => {
    const slider = sliderRef.current;
    if (!slider) return;
    
    const rect = slider.getBoundingClientRect();
    const offsetX = clientX - rect.left;
    const percentage = Math.max(0, Math.min(1, offsetX / rect.width));
    setKilometers(Math.round(percentage * 1000));
  }, []);

  // Mouse event handlers
  const handleMouseClick = useCallback((e) => {
    handleSliderInteraction(e.clientX);
  }, [handleSliderInteraction]);

  const handleMouseDrag = useCallback((e) => {
    if (isDragging) {
      handleSliderInteraction(e.clientX);
    }
  }, [isDragging, handleSliderInteraction]);

  const startMouseDrag = useCallback((e) => {
    setIsDragging(true);
    handleSliderInteraction(e.clientX);
  }, [handleSliderInteraction]);

  // Touch event handlers
  const handleTouchClick = useCallback((e) => {
    e.preventDefault();
    handleSliderInteraction(e.touches[0].clientX);
  }, [handleSliderInteraction]);

  const handleTouchDrag = useCallback((e) => {
    if (isDragging) {
      e.preventDefault();
      handleSliderInteraction(e.touches[0].clientX);
    }
  }, [isDragging, handleSliderInteraction]);

  const startTouchDrag = useCallback((e) => {
    setIsDragging(true);
    handleSliderInteraction(e.touches[0].clientX);
  }, [handleSliderInteraction]);

  const endDrag = useCallback(() => {
    setIsDragging(false);
  }, []);

  // Update the event listeners
  useEffect(() => {
    window.addEventListener('mousemove', handleMouseDrag);
    window.addEventListener('mouseup', endDrag);
    window.addEventListener('touchmove', handleTouchDrag, { passive: false });
    window.addEventListener('touchend', endDrag);
    
    return () => {
      window.removeEventListener('mousemove', handleMouseDrag);
      window.removeEventListener('mouseup', endDrag);
      window.removeEventListener('touchmove', handleTouchDrag);
      window.removeEventListener('touchend', endDrag);
    };
  }, [handleMouseDrag, handleTouchDrag, endDrag]);

  const formatCurrency = (amount) => {
    return new Intl.NumberFormat('en-LK', {
      style: 'currency',
      currency: 'LKR'
    }).format(amount);
  };

  const formatUSD = (amount) => {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 2
    }).format(amount);
  };










  return (
    <>
   <div className="booking-section-image">
        <img src="/middlebanner.png" alt="description_image" />
   </div>







<div className="tour-cost-calculation-container">
      <h2 className="heading-calculate-cost">Calculate the Estimated Cost</h2>
      <p className="subheading">Select a vehicle and adjust the distance to get an instant cost estimate</p>
      
      <div className="vehicle-selection">
        <h3>Select Your Vehicle</h3>
        <div className="vehicle-cards">
          {vehicles.map(vehicle => (
            <div 
              key={vehicle.id}
              className={`vehicle-card ${selectedVehicle?.id === vehicle.id ? 'selected' : ''}`}
              onClick={() => setSelectedVehicle(vehicle)}
            >
              <div className="vehicle-icon">
                {vehicle.name.includes('Car') && <i className="fas fa-car"></i>}
                {vehicle.name.includes('Van') && <i className="fas fa-van-shuttle"></i>}
                {vehicle.name.includes('SUV') && <i className="fas fa-truck-monster"></i>}
                {vehicle.name.includes('Bus') && <i className="fas fa-bus"></i>}
              </div>
              <h4>{vehicle.name}</h4>
              <p className="capacity">{vehicle.capacity}</p>
              <p className="price">{formatUSD(vehicle.usdPrice)}/km ({formatCurrency(vehicle.pricePerKm)}/km)</p>
            </div>
          ))}
        </div>
      </div>
      
      {selectedVehicle && (
        <div className="selected-vehicle-details">
          <h3>Selected: {selectedVehicle.name}</h3>
          <p><strong>Models:</strong> {selectedVehicle.models}</p>
          <p><strong>Capacity:</strong> {selectedVehicle.capacity}</p>
          <p><strong>Comfort:</strong> {selectedVehicle.comfort}</p>
        </div>
      )}
      
      <div className="distance-selection">
        <h3>Select Distance</h3>
        <div 
          className="slider-container"
          ref={sliderRef}
          onClick={handleMouseClick}
          onTouchStart={handleTouchClick}
        >
          <div className="slider-track">
            <div 
              className="slider-fill" 
              style={{ width: `${(kilometers / 1000) * 100}%` }}
            ></div>
            <div 
              className="slider-thumb" 
              style={{ left: `${(kilometers / 1000) * 100}%` }}
              onMouseDown={startMouseDrag}
              onTouchStart={startTouchDrag}
            ></div>
          </div>
          <div className="slider-scale">
            {[0, 100, 200, 300, 400, 500, 600, 700, 800, 900, 1000].map((point) => (
              <div key={point} className="scale-point">
                <div className="scale-tick"></div>
                <span>{point}</span>
              </div>
            ))}
          </div>
        </div>
        <div className="distance-display">
          <span className="distance-value">{kilometers} km</span>
        </div>
      </div>
      
      {selectedVehicle && (
        <div className="cost-calculation">
          <h3>Estimated Cost</h3>
          <div className="cost-breakdown">
            <p>{kilometers} km × {formatCurrency(selectedVehicle.pricePerKm)}/km</p>
            <h2 className="total-cost">{formatCurrency(cost)}</h2>
            <p className="usd-equivalent">({formatUSD(kilometers * selectedVehicle.usdPrice)})</p>
          </div>
        </div>
      )}
    </div>












    <div className="booking-with-map">
      <h2>Vehicle Booking - Chavo Tours</h2>

        {/* Step Indicators */}
        <div className="step-indicators">
          <div className={`step ${getStepClass(1)}`}>Step 1</div>
          <div className={`step ${getStepClass(2)}`}>Step 2</div>
          <div className={`step ${getStepClass(3)}`}>Step 3</div>
          <div className={`step ${getStepClass(4)}`}>Step 4</div>
        </div>

        {step === 1 && (
          <>
            <div className="form-group">
              <label htmlFor="pickup">Pickup Location</label>
              <input
                type="text"
                id="pickup"
                name="pickup"
                placeholder="Enter pickup location (e.g., Colombo Airport)"
                value={pickup}
                onChange={(e) => setPickup(e.target.value)}
                required
              />
            </div>

            <div className="form-group">
              <label htmlFor="dropoff">Drop-off Location</label>
              <input
                type="text"
                id="dropoff"
                name="dropoff"
                placeholder="Enter drop-off location (e.g., Galle Face Hotel)"
                value={dropoff}
                onChange={(e) => setDropoff(e.target.value)}
                required
              />
            </div>

            <div className="form-group">
              <label htmlFor="childrenCount">Children Count</label>
              <select
                id="childrenCount"
                name="childrenCount"
                value={childrenCount}
                onChange={(e) => setChildrenCount(e.target.value)}
              >
                {[...Array(6).keys()].map(i => (
                  <option key={i} value={i}>{i}</option>
                ))}
              </select>
            </div>

            <div className="form-group">
              <label htmlFor="adultsCount">Adults Count</label>
              <select
                id="adultsCount"
                name="adultsCount"
                value={adultsCount}
                onChange={(e) => setAdultsCount(e.target.value)}
              >
                {[...Array(6).keys()].map(i => (
                  <option key={i} value={i + 1}>{i + 1}</option>
                ))}
              </select>
            </div>

            <div className="form-group">
              <label htmlFor="vehicleType">Select Your Vehicle</label>
              <select
                id="vehicleType"
                name="vehicleType"
                value={vehicleType}
                onChange={(e) => setVehicleType(e.target.value)}
                required
              >
                <option value="">-- Select a Vehicle --</option>
                <option value="Negotiable-vehicle">Negotiable Vehicle</option>
                <option value="suzuki-wagon-r">Suzuki Wagon R</option>
                <option value="toyota-prius">Toyota Prius</option>
                <option value="suv">SUV</option>
                <option value="minivan">Minivan</option>
                <option value="KDH-Flat-roof">KDH Flat roof</option>
                <option value="KDH-High-roof">KDH high Roof</option>
                <option value="toyota-axio">Toyota Axio</option>
                <option value="toyota-aqua">Toyota Aqua</option>
                <option value="honda-fit">Honda Fit</option>
                <option value="suzuki-alto">Suzuki Alto</option>
                <option value="nissan-leaf">Nissan Leaf</option>
                <option value="toyota-vitz">Toyota Vitz</option>
                <option value="toyota-hiace">Toyota HiAce</option>
                <option value="mitsubishi-pajero">Mitsubishi Pajero</option>
                <option value="mitsubishi-lancer">Mitsubishi Lancer</option>
                <option value="land-rover-defender">Land Rover Defender</option>
                <option value="toyota-corolla">Toyota Corolla</option>
                <option value="mitsubishi-rosa-bus">Mitsubishi Rosa Bus</option>
                <option value="mini-cooper">Mini Cooper</option>
                <option value="volkswagen-beetle">Volkswagen (Beetle)</option>
                <option value="nissan-sunny">Nissan Sunny</option>
                <option value="honda-civic">Honda Civic</option>
                <option value="canter-truck">Canter Truck</option>
                <option value="morris-minor">Morris Minor</option>
                <option value="maruti-800">Maruti (800)</option>
                <option value="mitsubishi-jeep-4dr5">Mitsubishi Jeep (4DR5)</option>
                <option value="toyota-land-cruiser">Toyota Land Cruiser</option>
              </select>
            </div>

            <div className="form-group">
              <label htmlFor="transferType">Transfer Type</label>
              <select
                id="transferType"
                name="transferType"
                value={transferType}
                onChange={(e) => setTransferType(e.target.value)}
              >
                <option value="one-way">One-way</option>
                <option value="two-way">Two-way</option>
              </select>
            </div>
          </>
        )}

        {step === 2 && (
          <>
            <h3 className='heading-for-date'>Schedule Your Pickup Date & Time</h3>
            <div className="form-group">
              <label htmlFor="pickupDate">Pickup Date</label>
              <input
                type="date"
                id="pickupDate"
                name="pickupDate"
                value={pickupDate}
                onChange={handleDateChange}
                min={new Date().toISOString().split('T')[0]}
                required
              />
            </div>

            <div className="form-group">
              <label htmlFor="pickupTime">Pickup Time</label>
              <select
                id="pickupTime"
                name="pickupTime"
                value={pickupTime}
                onChange={handleTimeChange}
                required
              >
                <option value="">Select Time</option>
                {generateTimeOptions().map((time, index) => (
                  <option key={index} value={time}>{time}</option>
                ))}
              </select>
            </div>
          </>
        )}

        {step === 3 && (
          <>
            <div className="contact-details">
              <h3>Contact Details</h3>
              <div className="form-group row">
                <div className="column">
                  <label htmlFor="firstName">First Name</label>
                  <input
                    type="text"
                    id="firstName"
                    name="firstName"
                    value={firstName}
                    onChange={(e) => setFirstName(e.target.value)}
                    required
                  />
                </div>
                <div className="column">
                  <label htmlFor="lastName">Last Name</label>
                  <input
                    type="text"
                    id="lastName"
                    name="lastName"
                    value={lastName}
                    onChange={(e) => setLastName(e.target.value)}
                    required
                  />
                </div>
              </div>

              <div className="form-group row">
                <div className="column">
                  <label htmlFor="email">Email</label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    pattern=".+@.+"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                  />
                </div>
                <div className="column">
                  <label htmlFor="phone">Phone No</label>
                  <input
                    type="tel"
                    id="phone"
                    name="phone"
                    maxLength="10"
                    pattern="\d{10}"
                    value={phone}
                    onChange={(e) => setPhone(e.target.value)}
                  />
                </div>
              </div>

              <div className="form-group">
                <label htmlFor="comment">Additional Comments</label>
                <textarea
                  id="comment"
                  name="comment"
                  placeholder="Kindly provide your pickup location using a Google Maps or Apple Maps link"
                  value={comment}
                  onChange={(e) => setComment(e.target.value)}
                />
              </div>
            </div>
          </>
        )}

        {step === 4 && (
          <div className="payment-method">
            <h3>Payment Method</h3>
            <div className="payment-option">
              <label htmlFor="cash">
                <span><i className="fas fa-money-bill-wave"></i> CASH</span>
              </label>
            </div>
          </div>
        )}

        <div className="button-container">
          {step > 1 && (
            <button className="previous-button" onClick={handlePreviousStep}>Previous</button>
          )}
          
          {step < 4 && (
            <button className="next-button" onClick={handleNextStep}>Next</button>
          )}
        </div>

        {step === 4 && (
          <button
            className="submit-button-booking"
            onClick={handleBookingSubmit}
            disabled={loading}
          >
            {loading ? "Processing..." : "Book Now"}
          </button>
        )}
      </div>
    
    </>
  );
}

export default Booking;